export const ADD_SORT_FILTER_PARAMS = 'ADD_SORT_FILTER_PARAMS'
export const CLEAR_PROJECT_ARRAY = 'CLEAR_PROJECT_ARRAY'
export const SET_CREATOR_FILTER_VALUE = 'SET_CREATOR_FILTER_VALUE'
export const SET_GAME_FILTER_VALUE = 'SET_GAME_FILTER_VALUE'
export const SET_SORT_VALUE = 'SET_SORT_VALUE'
